var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as BrandFactory from "../../classes/definitions/brand/brand";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import BrandsList from '../../components/Brands/BrandsList/BrandsList';
import AppRoutes from '../../config/appRoutes';
import BrandsReduxProps from "./BrandsReduxProps";
var Brands = /** @class */ (function (_super) {
    __extends(Brands, _super);
    function Brands() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            data: [],
            meta: null
        };
        _this.getAllBrands = function (pageNum) {
            _this.api.getBrands(pageNum)
                .then(function (response) {
                var brands = BrandFactory.createBrands(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: brands, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с брандове', _this.props.history);
            });
        };
        _this.toNewBrand = function () {
            _this.props.history.push(AppRoutes.brand.path);
        };
        return _this;
    }
    Brands.prototype.componentDidMount = function () {
        this.getAllBrands(1);
    };
    Brands.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0411\u0440\u0430\u043D\u0434\u043E\u0432\u0435"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewBrand, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u0431\u0440\u0430\u043D\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(BrandsList, { gridData: data, meta: meta, getAllBrands: this.getAllBrands }))))));
    };
    return Brands;
}(React.Component));
export default connect(null, BrandsReduxProps.mapDispatchToProps)(Brands);



//////////////////
// WEBPACK FOOTER
// ./src/views/Brands/Brands.tsx
// module id = 537
// module chunks = 0